import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { TabViewModule } from 'primeng/tabview';

import { CoreModule } from 'src/app/core/core.module';
import { ServiceLogsRoutingModule } from './service-logs-routing.module';
import { ServiceLogsViewerComponent } from './service-logs-viewer/service-logs-viewer.component';

@NgModule({ declarations: [
        ServiceLogsViewerComponent
    ], imports: [CoreModule,
        ServiceLogsRoutingModule,
        CommonModule,
        FormsModule,
        TableModule,
        ButtonModule,
        DropdownModule,
        InputTextModule,
        TooltipModule,
        MessagesModule,
        TabViewModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ServiceLogsModule { }
